import Header from '../../components/Header'
import MediaMatch from '../../components/MediaMatch'
import Footer from '../../components/Footer'
import Tooltip from '../../components/Tooltip'
import ImgGimplus from '../../assets/img/gimplus/plano-recompensa-gimplus.png'

import { Breadcrumb, BreadcrumbItem } from '../../styles/breadcrumb'
import ProfileSideMenu from '../../components/MenuProfile'
import { ProfileTitle } from '../../components/FormChangePassword/styles'
import Filter from '../../components/Filter'
import IconFilter from '../../assets/img/icon-filter.svg'
import {
  FilterMobileButton,
  FilterMobileWrapper
} from '../../components/Filter/styles'
import { useState, useEffect } from 'react'
import FilterMobile from '../../components/FilterMobile'
import EmptyBox from '../../components/EmptyBox'
import { useSelector, useDispatch } from 'react-redux'
import { setPage, setQuery } from '../../store/ducks/pagination'
import * as S from '../../styles/page-profile'
import {
  ButtonExportar,
  GimplusFilterContainer,
  GimplusTitle,
  SaldoMessage
} from '../../styles/gimplus'
import TabelaGimplus from '../../components/Table/TableGimplus'
import gimplus from '../../api/gimplus'
import { convertDecimalCurrency } from '../../utils/utils'
import csvDataBuilder from './csvData'
import { CSVLink } from 'react-csv'
import Loader from '../../components/Loader'
import { useToast } from '../../hooks/toast'
import Paginator from '../../components/Paginator'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'
import { useLocation } from 'react-router-dom'
import { GetGimplusExtratoRequest } from '../../types/gimplus'
import { useQuery } from 'react-query'
import {
  getGimplusExtrato,
  getGimplusSaldo
} from '../../hooks/gimplus/useGimplus'

function Gimplus() {
  const store: any = useSelector((reduxState) => reduxState)
  const dispatch = useDispatch()
  const { addToast }: any = useToast()

  // const [saldo, setSaldo] = useState<any>('0,00')
  const [showMenu, setShowMenu] = useState(false)
  const [csvData, setCsvData] = useState([])
  const [loader, setLoader] = useState(false)
  const [loaderContent, setLoaderContent] = useState(false)

  const [filterParams, setFilterParams] = useState<GetGimplusExtratoRequest>({
    TipoOperacao: '',
    Numero: '',
    DataInicial: '',
    DataFinal: '',
    Page: 1,
    PageSize: 10
  })

  const saldo = useQuery('gimplus-saldo', getGimplusSaldo, {
    staleTime: 1000 * 60 // 1 minuto,
  })

  const { data, isLoading } = useQuery(
    [
      'gimplus-extrato',
      filterParams.TipoOperacao,
      filterParams.Numero,
      filterParams.DataInicial,
      filterParams.DataFinal,
      filterParams.Page,
      filterParams.PageSize
    ],
    () =>
      getGimplusExtrato(
        filterParams.TipoOperacao,
        filterParams.Numero,
        filterParams.DataInicial,
        filterParams.DataFinal,
        filterParams.Page,
        filterParams.PageSize
      ),
    {
      // enabled: false,
      onError: () => {
        addToast({
          type: 'error',
          title: 'Não foi possível realizar busca',
          description: `Verifique os campos e tente novamente`
        })
      },
      staleTime: 1000 * 60 // 1 minuto,
    }
  )

  const openMenu = () => {
    setShowMenu((prev) => !prev)
  }

  const fetch = async (
    tipoOperacao: string,
    numero: string,
    di: string,
    df: string,
    pg: number
  ) => {
    try {
      setFilterParams({
        TipoOperacao: tipoOperacao,
        Numero: numero,
        DataInicial: di,
        DataFinal: df,
        Page: pg
      })

      console.log(filterParams)

      //Reseta o state com o pedidoId após primeiro fetch com o ID
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Não foi possível realizar busca',
        description: `Verifique os campos e tente novamente`
      })

      return err
    }
  }

  const location = useLocation()

  useEffect(() => {
    getLocalStorageLog(location.pathname)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setCsvData(csvDataBuilder(data?.data))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.pageNumber])

  return (
    <S.Main>
      {!!isLoading && <Loader />}
      <FilterMobile
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        gimplus
        pedido
        small
        click={fetch}
        opcoes={[
          { value: '', label: 'Todas' },
          { value: 'd', label: 'Débito' },
          { value: 'c', label: 'Crédito' }
        ]}
        promotor={undefined}
      />
      <Header></Header>
      <S.Profile className="perfil">
        <S.PageContent className="page-content">
          <S.Wrapper className="wrapper">
            <S.ColGroup className="col-group">
              <ProfileSideMenu />
              <S.ProfileContent className="col-9">
                {/* Área para inserir os novo componentes criados para ficar ao lado do menu lateral de perfil */}
                <Breadcrumb>
                  <BreadcrumbItem>Inicio</BreadcrumbItem>
                  <BreadcrumbItem>Gimplus</BreadcrumbItem>
                </Breadcrumb>

                {!!isLoading ? (
                  <Loader></Loader>
                ) : (
                  <>
                    <MediaMatch greaterThan="1171px">
                      <GimplusTitle>
                        <div>
                          <ProfileTitle>Histórico Gimplus</ProfileTitle>
                          <SaldoMessage>
                            <p>Saldo total disponível</p>
                            <Tooltip
                              icon={<i className="icon icon-info"></i>}
                              message={
                                saldo.data?.ValorPontos === 0
                                  ? 'Continue comprando para acumular créditos, o valor mínimo para utilização é de R$ 1,00.'
                                  : 'Valor do crédito limitado a 90% do valor total dos produtos.'
                              }
                              label={undefined}
                              right={undefined}
                              left={undefined}
                            />
                            <h3>
                              <strong>
                                {!!saldo.data?.ValorPontos
                                  ? convertDecimalCurrency(
                                      saldo.data?.ValorPontos
                                    )
                                  : 'R$ 0,00'}
                              </strong>
                            </h3>
                          </SaldoMessage>
                        </div>
                        <img src={ImgGimplus} alt="" />
                      </GimplusTitle>

                      <GimplusFilterContainer>
                        <Filter
                          click={fetch}
                          gimplus
                          pedido
                          small
                          opcoes={[
                            { value: '', label: 'Todas' },
                            { value: 'd', label: 'Débito' },
                            { value: 'c', label: 'Crédito' }
                          ]}
                          promotor={undefined}
                          setShowMenu={undefined}
                          calendarModal={undefined}
                        />

                        {data.data.length > 0 ? (
                          <ButtonExportar>
                            <CSVLink
                              data={csvData}
                              filename={'extrato-gimplus.csv'}
                            >
                              Exportar
                            </CSVLink>
                          </ButtonExportar>
                        ) : (
                          <ButtonExportar>Exportar</ButtonExportar>
                        )}
                      </GimplusFilterContainer>
                    </MediaMatch>

                    <MediaMatch lessThan="1170px">
                      <FilterMobileWrapper>
                        <div>
                          <ProfileTitle>Histórico Gimplus</ProfileTitle>
                          <SaldoMessage>
                            <p>Saldo total disponível</p>
                            <Tooltip
                              icon={<i className="icon icon-info"></i>}
                              message={
                                saldo.data?.ValorPontos === 0
                                  ? 'Continue comprando para acumular créditos, o valor mínimo para utilização é de R$ 1,00.'
                                  : 'Valor disponível apenas para produtos Gimba.'
                              }
                              label={undefined}
                              right={undefined}
                              left={undefined}
                            />
                            <h3>
                              <strong>
                                {!!saldo.data?.ValorPontos
                                  ? convertDecimalCurrency(
                                      saldo.data?.ValorPontos
                                    )
                                  : 'R$ 0,00'}
                              </strong>
                            </h3>
                          </SaldoMessage>
                        </div>

                        <FilterMobileButton
                          align={false}
                          onClick={(e) => {
                            e.preventDefault()
                            openMenu()
                          }}
                        >
                          <img src={IconFilter} alt="" />
                        </FilterMobileButton>
                      </FilterMobileWrapper>
                    </MediaMatch>

                    {data.data.length === 0 ? (
                      <EmptyBox>Nenhum registro encontrado.</EmptyBox>
                    ) : (
                      <TabelaGimplus data={data.data}></TabelaGimplus>
                    )}

                    {/* <PageSelector click={fetch} /> */}
                    <Paginator click={fetch}></Paginator>
                  </>
                )}
                {/* Fim da área de conteúdo da página */}
              </S.ProfileContent>
            </S.ColGroup>
          </S.Wrapper>
        </S.PageContent>
      </S.Profile>
      <Footer />
    </S.Main>
  )
}

export default Gimplus
